import React, {useEffect, useState} from "react";
import {useService} from "../../../../base/hooks/useService";
import DynamicWidgetsService from "../../../../services/DynamicWidgetsService";
import {useLoading} from "../../../../base/hooks/useLoading";
import joinClassNames from "../../../../base/helpers/joinClassNames";
import {Card, CardBody, Spinner} from "reactstrap";
import Breadcrumb from "../../../../base/components/Common/Breadcrumb2";
import Icon from "../../../../base/components/Icon";
import CreateWidgetModal from "./CreateEditWidget/CreateWidgetModal";
import EditWidgetModal from "./CreateEditWidget/EditWidgetModal";
import ConfirmPopup from "../../../../base/components/ConfirmPopup";

import classes from "./DynamicWidgets.module.scss";
import ReactSwitch from "../../../../base/components/Switch";
import ToasterService from "../../../../services/ToastService";
import {isServiceEditable} from "../../../../base/helpers/adminRolePermissions";

const mockData = [
    {
        id: 1,
        label: "Title 1",
        unit: "Unit 1",
        status: 1,
        icon: {
            bytes: 8162,
            id: 22,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png",
            name: "optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png"
        },
        placeholderIcon: {
            bytes: 11974,
            id: 7739,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_08c72987-7616-406f-856e-96644b52679d.png",
            name: "optimallyme_08c72987-7616-406f-856e-96644b52679d.png"
        }
    },
    {
        id: 2,
        label: "Title 2",
        unit: "Unit 2",
        status: 1,
        icon: {
            bytes: 8162,
            id: 22,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png",
            name: "optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png"
        },
        placeholderIcon: {
            bytes: 11974,
            id: 7739,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_08c72987-7616-406f-856e-96644b52679d.png",
            name: "optimallyme_08c72987-7616-406f-856e-96644b52679d.png"
        }
    },
    {
        id: 3,
        label: "Title 3",
        unit: "Unit 3",
        status: 1,
        icon: {
            bytes: 8162,
            id: 22,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png",
            name: "optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png"
        },
        placeholderIcon: {
            bytes: 11974,
            id: 7739,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_08c72987-7616-406f-856e-96644b52679d.png",
            name: "optimallyme_08c72987-7616-406f-856e-96644b52679d.png"
        }
    },
    {
        id: 4,
        label: "Title 4",
        unit: "Unit 4",
        status: 0,
        icon: {
            bytes: 8162,
            id: 22,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png",
            name: "optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png"
        },
        placeholderIcon: {
            bytes: 11974,
            id: 7739,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_08c72987-7616-406f-856e-96644b52679d.png",
            name: "optimallyme_08c72987-7616-406f-856e-96644b52679d.png"
        }
    },
    {
        id: 5,
        label: "Title 5",
        unit: "Unit 5",
        status: 0,
        icon: {
            bytes: 8162,
            id: 22,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png",
            name: "optimallyme_657cfafa-c5d6-45e9-b860-4e7fb2df26ca.png"
        },
        placeholderIcon: {
            bytes: 11974,
            id: 7739,
            link: "https://optimallyme-bucket-dev-content.s3.eu-central-1.amazonaws.com/files/admins/optimallyme_08c72987-7616-406f-856e-96644b52679d.png",
            name: "optimallyme_08c72987-7616-406f-856e-96644b52679d.png"
        }
    }
]

export default function DynamicWidgets() {
    /**
     * @type {DynamicWidgetsService}
     */
    const widgetsService = useService(DynamicWidgetsService);
    /**
     * @type {ToasterService}
     */
    const toastService = useService(ToasterService);

    const [isLoading, {registerPromise}] = useLoading(false);
    const [widgets, setWidgets] = useState([]);
    const [showCreateWidget, updateShowCreateWidget] = useState(false);
    const [showEditWidget, updateShowEditWidget] = useState(false);
    const [showDeletePopup, updateShowDeletePopup] = useState(false);

    const breadcrumbs = {
        title: "Dynamic Widgets", breadcrumbItems: []
    };

    const getDynamicWidgets = () => {
        registerPromise(widgetsService.getAdminsWidgets())
            .then(({entities}) => {
                setWidgets(entities)
            })
    }

    const changeWidgetStatus = (widget, newValue) => {
        const {label, unit, icon, placeholderIcon} = widget;
        const newData = {
            label,
            unit,
            iconId: icon.id,
            placeholderIconId: placeholderIcon.id,
            status: newValue
        }
        registerPromise(widgetsService.editAdminsWidget(widget.id, newData))
            .then(() => {
                toastService.success("Widget status has been successfully changed")
            })
            .finally(() => {
                getDynamicWidgets()
            })
    }

    useEffect(() => {
        getDynamicWidgets()
    }, [])

    const isDynamicWidgetsEditable = isServiceEditable("Dynamic Widgets");

    return (
        <div>
            {isLoading ?
                <section className="mt-3 d-flex flex-column justify-content-center align-items-center w-100 h-100">
                    <Spinner color="info"/>
                </section>
                : <div>
                    <Breadcrumb {...breadcrumbs} />
                    <div className={joinClassNames(classes.DynamicWidgetsContainer)}>
                        {widgets?.map((widget, index) => {
                            return <Card key={index}>
                                <CardBody>
                                    <div className="d-flex justify-content-between h-100">
                                        <div className="d-flex">
                                            <div className={joinClassNames(classes.DynamicWidgetsHFit, "bg-light-gray rounded-1 p-1 me-3")}>
                                                <img className={joinClassNames(classes.DynamicWidgetsIcon, "bg-light-gray")} src={widget.icon.link} alt={`icon ${index}`} />
                                            </div>
                                            <div>
                                                <p className="font-weight-semibold">{widget.label}</p>
                                                <p>{widget.unit}</p>
                                            </div>
                                        </div>
                                        {isDynamicWidgetsEditable &&
                                            <div className="d-flex flex-column justify-content-between align-items-stretch">
                                                <div className="d-flex gap-1 align-items-end justify-content-end">
                                                    <Icon
                                                        icon={"edit"}
                                                        width={20}
                                                        height={20}
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            updateShowEditWidget(widget)
                                                        }}
                                                        className="cursor-pointer me-2"
                                                    />
                                                    <Icon
                                                        icon={"trashIcon"}
                                                        width={20}
                                                        height={20}
                                                        onClick={() => { updateShowDeletePopup(widget) }}
                                                        className="cursor-pointer"
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <ReactSwitch
                                                        state={widget.status}
                                                        updateState={() => changeWidgetStatus(widget, !widget.status)}
                                                        onText="Active"
                                                        offText="Disabled"
                                                        switchWidth={85}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                        })}
                        {isDynamicWidgetsEditable &&
                            <Card key={widgets?.length + 1}>
                                <CardBody>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <Icon
                                            className={joinClassNames("cursor-pointer", classes.DynamicWidgetsAddIcon)}
                                            icon="plus"
                                            onClick={() => {
                                                updateShowCreateWidget(true)
                                            }}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        }
                    </div>
                    <CreateWidgetModal
                        isOpen={showCreateWidget}
                        onClose={() => updateShowCreateWidget(false)}
                        afterCreate={() => getDynamicWidgets()}
                    />
                    {showEditWidget && <EditWidgetModal
                        isOpen={showEditWidget}
                        onClose={() => updateShowEditWidget(false)}
                        widget={showEditWidget}
                        afterEdit={() => getDynamicWidgets()}
                    />}
                    {showDeletePopup &&
                        <ConfirmPopup
                            isOpen={showDeletePopup}
                            updateIsOpen={updateShowDeletePopup}
                            onSubmit={() => {
                                registerPromise(widgetsService.deleteAdminsWidget(showDeletePopup.id))
                                    .then(() => {
                                        setWidgets(widgets.filter(w => w.id !== showDeletePopup.id));
                                        updateShowDeletePopup(false);
                                    });
                            }}
                            title="Delete Dynamic Widget"
                            description="Are you sure you want to delete the widget?"
                            submitBtnText="Delete"
                        />
                    }
                </div>}
        </div>
    )
}